<template>
  <div class="page lieviti-in-crema-alta-fermentazione">
    <ListingList
      :indexes="indexes"
      :defaultFacetsFilters="defaultFacetsFilters"
      :filter="filter"
      :pageHandle="birraPage.typeHandle"
      :categories="categories"
      :subcategories="subcategories"
      :introSection="currentSubCategory.sezioneIntroProdotti[0]"
      :parentIntroSectionImage="birraPage.sezioneIntroProdotti[0].portrait"
      :hideSidebar="true"
    />
    <ListingIntro
      :introSection="currentSubCategory.sezioneIntroProdotti[0]"
      class="hide-for-large"
    />
    <PagesVinoBirraPreFooterSection
      :preFooterSection="currentSubCategory.sezionePreFooter[0]"
    />
  </div>
</template>

<script setup>
import { useStore } from '@/store/index.js'
import queries from '@/graphql/craft/queries/index.js'
import { parseQueryFacets } from '~/assets/js/utils/algolia.js'
import {
  useBirraData,
  generateBirraDefaultFacetsFilters,
} from '~/composables/birra-data.js'
import { useHelpers } from '~/composables/helpers.js'

const route = useRoute()
const indexes = ['section_birra']
const filter = route.query?.filter ? parseQueryFacets(route.query?.filter) : []

const { configuration } = useStore()

const query = queries.birraPage.getBirraPage
const variables = computed(() => ({
  site: configuration.site,
}))

const { data } = await useGraphql(query, variables)
if (!data.value.birraPageEntries?.[0]) {
  throw createError({ statusCode: 404 })
}

const { categories, subcategories } = useBirraData(data)

const currentCategory = computed(() => {
  return (
    data.value.categories.find(
      (category) => category.slug === route.params.slug,
    ) || {}
  )
})

const currentSubCategory = computed(() => {
  return (
    data.value.categories.find(
      (category) => category.key === 'alta-fermentazione',
    ) || {}
  )
})

const isValidCategory = computed(() => {
  return (
    currentCategory.value.key === 'lieviti-in-crema' &&
    currentSubCategory.value.key === 'alta-fermentazione'
  )
})

if (!isValidCategory.value) {
  throw createError({ statusCode: 404 })
}

const defaultFacetsFilters = computed(() => {
  const defaultFacets = generateBirraDefaultFacetsFilters(currentCategory)

  return [...defaultFacets, ['Filtro_Fermentazione_Birra: Alta fermentazione']]
})

const seo = computed(() => currentSubCategory.value.seo || {})

const localeParams = computed(() => currentSubCategory.value.localized || [])

useSeo({
  ...seo.value,
  localeParams: useHelpers().generateSeoLocaleParams(localeParams, 'slug'),
  meta: [
    {
      name: 'description',
      content: seo.value?.description,
    },
  ],
})

const birraPage = computed(() => data.value.birraPageEntries?.[0])
</script>
